export function resetPasswordStateSelector(state) {
  return state.local.currentUser.passwordReset
}
